import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { QUERY_KEYS } from 'src/constants'

import { commonService } from 'src/services'
import { IPublicAccountsResponse } from 'src/types'

export const useGetPublicAccounts = (
  params: { page?: number; pageSize?: number; search?: string, aiSearch?: boolean, sortBy?: string, sortOrder?: 'DESC' | "ASC" } = {},
  options?: UseQueryOptions<IPublicAccountsResponse>,
) => {
  return useQuery(
    [QUERY_KEYS.GET_PUBLIC_ACCOUNTS, params],
    () => commonService.getPublicAccounts(params),
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000, // 5 minutes
      ...options,
    },
  )
}
